import React, { useState } from "react";
import Header from "../../components/HomeHeader/HomeHeader.jsx";
import "./home.css";
import { PostMethod } from "../../NetworkCalls/Post.js";
import Footer from "../../components/Footer/Footer.jsx";
import swal from "sweetalert";
function Home() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = () => {
    if (name == "" || email == "" || subject == "" || description == "") {
      swal({
        title: "Validation Error",
        text: "Please fill all fields.",
        type: "error",
        showCancelButton: false,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Ok",
        closeOnConfirm: false,
      });
    } else {
      const body = {
        name: name,
        email: email,
        subject: subject,
        description: description,
      };

      PostMethod('contact',body).then((res)=>{
        swal({
          title: "Success",
          text: "Email has been sent successfully",
          type: "success",
          showCancelButton: false,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "Ok",
          closeOnConfirm: false,
        });
        setDescription("")
        setEmail("")
        setName("")
        setSubject("")
      }).catch((err)=>{
        swal({
          title: "Error",
          text: "Something went wrong",
          type: "error",
          showCancelButton: false,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "Ok",
          closeOnConfirm: false,
        });
      })
    }
  };

  return (
    <>
      <div className="home-body">
        <Header />

        <div className="home">
          <div className="home-container">
            <div className="home-container-div1">
              <p className="Heading">
                Bridging the gap between <br />
                <span style={{ color: "#5AFF6A" }}>on-chain</span> &{" "}
                <span style={{ color: "#5AFF6A" }}>off-chain</span> tokens.
              </p>
              <p>Revolutionary web 3.0 integration, one project at a time.</p>
            </div>
            <div className="home-container-div2">
              <p className="Heading">Get In Touch</p>
              <p style={{ margin: "10px 0px", textAlign: "left" }}>
                Want to have a DEX for your Project? Please feel free to contact
                us through the form below.
              </p>

              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Name"
              />
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
              />
              <input
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Subject"
              />

              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Description"
              />
              <div onClick={()=>handleSubmit()} className="send-button">
                <p>Send</p>
              </div>
            </div>
          </div>
          <p className="ComingSoon-text">More Projects Coming Soon</p>
        </div>
      </div>

      <div className="home-background"></div>
      <Footer />
    </>
  );
}

export default Home;
